import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/relatorio-medicamento-nao-atendido`

    return {
        paciente(queryParms = {}) {
            return repository.get(`${baseUrl}/autocomplete-paciente?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        index(queryParms){
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)

        }
    }
}